import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ManageAssessmentApiService } from '@core/services/api/manage-assessment-api.service';
import { PrimeNGSharedModule } from '@shared/prime/prime-ng.module';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-assessment-due-date-extension-popup',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PrimeNGSharedModule,  
  ],
  templateUrl: './assessment-due-date-extension-popup.component.html',
  styleUrl: './assessment-due-date-extension-popup.component.scss'
})
export class AssessmentDueDateExtensionPopupComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() config: any | null = null;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeDialog = new EventEmitter<void>();
  @Output() dueDateConfirmed = new EventEmitter<{}>();
  dueDateExtensionForm!: FormGroup;
  formSubmitted: boolean = false;
  minDate: Date = new Date();
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly manageAssessmentApi: ManageAssessmentApiService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    let currentDate = new Date();
    this.minDate.setDate(currentDate.getDate() + 1);
    this.dueDateExtensionForm = new FormGroup({
      newDueDate: new FormControl(null, Validators.required),
      remarks: new FormControl('',  Validators.required)
    });
  }

  close(): void {
    this.dueDateExtensionForm.reset();
    this.visible = false;
    this.closeDialog.emit();
  }

  formatDate = (date: Date | null): any => {
      return date instanceof Date
        ? this.datePipe.transform(date, "yyyy-MM-dd") || null
        : null;
    };

  onSubmit(): void {
    this.manageAssessmentApi.changeDueDate(this.config.assessmentId, {
      new_due_date: this.datePipe.transform(this.dueDateExtensionForm.value.newDueDate, "yyyy-MM-dd") || null,
      remarks: this.dueDateExtensionForm.value.remarks
    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.dueDateConfirmed.emit();
        this.close();
      },
      error: (error) => {
        console.error('Error extending due date:', error);
      }
    });
  }

  onDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
